function formatMoney(cents, currency = "") {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const value = (cents / 100);

  try {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency
    }).format(value);
  } catch (e) {
    // Fallback
    return (value).toFixed(2) + currency;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('add-both-container');
  if (!container) return;

  const product = window.__mainProduct;
  const productId = container.dataset.productId;
  if (!productId) return;

  // 1) Recommendations für dieses Produkt laden
  fetch(`/recommendations/products.json?product_id=${productId}&limit=1`)
    .then(res => res.json())
    .then(data => {
      const products = data.products || [];
      if (!products.length) {
        console.log('Keine Recommendations gefunden');
        return;
      }

      const reco = products[0];
      const recoVariantId = reco.variants[0]?.id;
      if (!recoVariantId) {
        console.log('Empfohlenes Produkt hat keine Variant-ID');
        return;
      }

      const variant_price = formatMoney(reco.variants[0].price, "€");


      console.log(reco)
      
      const preview = document.createElement('div');
preview.className = 'AddBothPreview';

preview.innerHTML = `
  <div class="AddBothPreview__Row" style="cursor:default !important">
    <img class="AddBothPreview__Image" src="${product.featured_image}" alt="${product.title}">
    <div class="AddBothPreview__Info">
      <div class="AddBothPreview__Title">${product.title}</div>
      <div class="AddBothPreview__Price">${product.price}</div>
    </div>
  </div>

  <div class="AddBothPreview__Row">
    
  <a href="${reco.url}" style="text-decoration:none" target="_blank"><img class="AddBothPreview__Image" src="${reco.featured_image}" alt="${reco.title}"></a>
  
  <a href="${reco.url}" style="text-decoration:none" target="_blank">
    <div class="AddBothPreview__Info">
      <div class="AddBothPreview__Title">${reco.title}</div>
      <div class="AddBothPreview__Price" style="cursor:pointer !important">${variant_price}</div>
    </div>
    </a>
  </div>
`;

// === Überschrift einsetzen ===
const heading = document.createElement('p');
heading.className = 'SectionHeader__SubHeading Heading u-h6';
heading.style.color = '#300c0c';
heading.style.textTransform = 'uppercase';
heading.textContent = 'Wird oft zusammen gekauft';


      // 2) Button direkt unter dem Buy-Button erzeugen
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'add-both';
      btn.className = 'ProductForm__AddToCart Button Button--primary Button--full AddBothButton';

      btn.textContent = 'Zusammen in den Warenkorb';

      // nur empfohlenes Variant im Dataset speichern
      btn.dataset.recommendedVariantId = recoVariantId;

      container.appendChild(heading);

      container.appendChild(preview);
      container.appendChild(btn);

      // 3) Klick-Handler: aktuelle Variant + Recommendation in den Cart
      btn.addEventListener('click', () => {
        // aktuelle Haupt-Variante aus dem Produkt-Form holen
        const variantInput = document.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );
        if (!variantInput) {
          console.error('Kein Varianten-Input gefunden');
          return;
        }

        const mainVariantId = Number(variantInput.value);
        const recommendedVariantId = Number(btn.dataset.recommendedVariantId);

        if (!mainVariantId || !recommendedVariantId) {
          console.error('Variant IDs fehlen');
          return;
        }

        
  setAddBothLoading(btn, true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              //{ id: mainVariantId, quantity: 1 },
              { id: recommendedVariantId, quantity: 1 }
            ]
          })
        })
          .then(res => res.json())
          .then(data => {
            console.log('Cart updated:', data);

            const defaultButton = document.querySelector(
              'form[action*="/cart/add"] button[type="submit"]'
            );
            if (defaultButton) {
              defaultButton.dispatchEvent(new Event('click', { bubbles: true }));
              
          setTimeout(() => {
              setAddBothLoading(btn, false);
          }, 2000);
            
          
            }

            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
          })
          .catch(console.error)
      });
    })
    .catch(err => console.error('Recommendations-Fehler:', err));
});

function setAddBothLoading(btn, isLoading) {
  if (isLoading) {
    // Original-Text merken (nur einmal)
    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent;
    }
    btn.disabled = true;
    btn.classList.add('AddBothButton--loading');
    btn.innerHTML = '<span class="AddBothButton__spinner"></span>';
  } else {
    btn.disabled = false;
    btn.classList.remove('AddBothButton--loading');
    btn.innerHTML = btn.dataset.originalText || 'Zusammen in den Warenkorb';
  }
}